import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import Anchor from './Anchor';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSpace from 'eco-design/base/eco-space';
import { FlashIcon } from '../icons';
import useCardsShowHook from '../useHooks/useCardsShowHook';

const KSPPicture: React.FC = () => {
    const { t } = useLang('Delta3AirSeries.B');

    const handlePushAnchor = (title: string, name: string, id1: string, id2: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_anchor',
            position: title,
            button_name: name,
            __btn_id1: `range1 .${id1}`,
            __btn_id2: id2,
            __btn_type: 'href',
        });
    };
    const sectionRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!sectionRef.current) return;
        const img = sectionRef.current.querySelector('.img');
        const ani1 = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                img?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    img?.classList.remove('enter');
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    useCardsShowHook('.rights-content .item', '.rights-content');
    return (
        <section className={`${styles.B} GtmModuleData-section range1`} id="List-sence-A" data-section-id="D3A-B">
            <EcoSpace />
            <EcoTitle title={t('title')} className={`eco-content B-title`}></EcoTitle>
            <div className="rights-content">
                <EcoLink
                    className="item item1 GtmModuleData-btn-href"
                    href="#List-sence-D"
                    onClick={() => handlePushAnchor('title', 'item1', 'item1', '#List-sence-D')}
                >
                    <div className="sub-text">
                        <div className="item-title">{t('item1_1')}</div>
                        <div className="item-desc">
                            <span className="desc1">{t('item1_2')}</span>
                            <span className="desc2">{t('item1_3')}</span>
                            <span className="desc3">{t('item1_4')}</span>
                            <span className="desc4">{t('item1_5')}</span>
                        </div>
                    </div>
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1763520703094/1.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1764239640012/06.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <span className="add-icon">
                        <Anchor />
                    </span>
                </EcoLink>

                <EcoLink
                    className="item item2 GtmModuleData-btn-href"
                    href="#List-sence-C"
                    onClick={() => handlePushAnchor('title', 'item2', 'item2', '#List-sence-C')}
                >
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1763520703231/2.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1764239637508/01.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <div className="sub-text">
                        <div className="item-title">{t('item2_1')}</div>
                        <div className="item-desc">{t('item2_2')}</div>
                    </div>
                    <span className="add-icon">
                        <Anchor />
                    </span>
                </EcoLink>

                <EcoLink
                    className="item item3 GtmModuleData-btn-href"
                    href="#List-sence-E"
                    onClick={() => handlePushAnchor('title', 'item3', 'item3', '#List-sence-E')}
                >
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1763520704298/3.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1764239638218/03.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <div className="sub-text">
                        <div className="item-title">{t('item3_1')}</div>
                    </div>
                    <span className="add-icon">
                        <Anchor />
                    </span>
                </EcoLink>

                <EcoLink
                    className="item item4 GtmModuleData-btn-href"
                    href="#D3A-QuietPower"
                    onClick={() => handlePushAnchor('title', 'item4', 'item4', '#D3A-QuietPower')}
                >
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1763520704034/4.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1764243137127/20251127-192927.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <div className="sub-text">
                        <div className="item-title">{t('item4_1')}</div>
                        <div className="item-desc">{t('item4_2')}</div>
                    </div>
                    <span className="add-icon">
                        <Anchor />
                    </span>
                </EcoLink>

                <EcoLink
                    className="item item5 GtmModuleData-btn-href"
                    href="#D3A-LongTermReliability"
                    onClick={() => handlePushAnchor('title', 'item5', 'item5', '#D3A-LongTermReliability')}
                >
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1763520704521/5.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1764239637938/04.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <div className="sub-text">
                        <div className="item-title">{t('item5_1')}</div>
                    </div>
                    <span className="add-icon">
                        <Anchor />
                    </span>
                </EcoLink>

                <EcoLink
                    className="item item6 GtmModuleData-btn-href"
                    href="#List-sence-B"
                    onClick={() => handlePushAnchor('title', 'item6', 'item6', '#List-sence-B')}
                >
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1763520703812/6.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1763537096049/Frame%20128720596.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <div className="sub-text">
                        <div className="item-title">{t('item6_1')}</div>
                        <div className="item-desc">
                            <div className="desc">{t('item6_2')}</div>
                            <div className="number">
                                <span className="number-1">
                                    <FlashIcon />
                                    {t('item6_3')}
                                </span>
                                <p className='interval'></p>
                                <span className="number-2">
                                    <FlashIcon />
                                    {t('item6_4')}
                                </span>
                            </div>
                        </div>
                    </div>
                    <span className="add-icon">
                        <Anchor />
                    </span>
                </EcoLink>
                <EcoLink className="item item7 GtmModuleData-btn-href">
                    <EcoImg
                        className="item-img"
                        pc="https://websiteoss.ecoflow.com/upload/image/1763520703523/7.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1763537096917/Frame%201000008979.jpg"
                        isOpenLazy
                    ></EcoImg>
                    <div className="sub-text">
                        <div className="item-title">{t('item7_1')}</div>
                    </div>
                    {/* <span className="add-icon">
                        <Anchor />
                    </span> */}
                </EcoLink>
            </div>
        </section>
    );
};

export default KSPPicture;
